import { createContext } from "reka-ui";
import type { ComputedRef, Ref } from "vue";

export interface SearchComboboxOption<T extends string = string> {
  id: T;
  label: string;
  disabled?: boolean;
  group?: string;
}

interface SearchComboboxContext {
  isOpen: Ref<boolean>;
  modelValue: Ref<string | undefined>;
  options: Ref<readonly SearchComboboxOption[]>;
  groupedOptions: ComputedRef<Record<string, SearchComboboxOption[]>>;
  query: Ref<string>;
  isPending: Ref<boolean>;
  align: Ref<"start" | "center" | "end">;
  matchTriggerWidth: Ref<boolean>;
  select: (next: string | undefined) => void;
}

export const [injectSearchComboboxContext, provideSearchComboboxContext] =
  createContext<SearchComboboxContext>("SearchCombobox.Root");
